import React from 'react';
import Firebase from './Firebase';

const App = () => {
    return <Firebase />;
};

export default App; 